import { render, staticRenderFns } from "./autocomplete-local.vue?vue&type=template&id=5245f905&"
import script from "./autocomplete-local.vue?vue&type=script&lang=js&"
export * from "./autocomplete-local.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports